import React, { useCallback, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { Container, Grid, Box, Tooltip } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import { Helmet } from "react-helmet";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import DatagridComp from "../DatagridComp";
import Commoncard from "../Commoncard";
import Rightsidebar from "../Rightsidebar/Rightsidebar";
import "./../style.css";
import "./outreachAssistant.css";
import Loader from "./../CommonLoader";
import CommonAlert from "../../../Commonalert/commonalert";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import RecipientsIcon from "./../Asset/esocardicon/outreach/addressbook.svg";
import CampaignIcon from "./../Asset/esocardicon/outreach/mailletter.svg";
import AIEmailIcon from "./../Asset/esocardicon/outreach/aisparkles.svg";
import SentMailIcon from "./../Asset/esocardicon/outreach/emailsent.svg";

const API_BASE = process.env.REACT_APP_API_URL;

const OUTREACH_FAQ_MENU_ID = 91;

export default function OutreachAssistant() {
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value;
  const userDomainId = esodata?.domaindata?.value?.header_selected || 1;

  const [CurrentMenu, setCurrentMenu] = useState("recipients");
  const [CurrentMenuName, setCurrentMenuName] = useState("Recipients");
  const [activeTab, setActiveTab] = useState("recipients");
  const [loading, setLoading] = useState(false);

  const [campaigns, setCampaigns] = useState([]);
  const [mediaRecipients, setMediaRecipients] = useState([]);
  const [campaignRecipients, setCampaignRecipients] = useState([]);
  const [generatedEmails, setGeneratedEmails] = useState([]);

  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [selectedCampaignId, setSelectedCampaignId] = useState("");
  const [selectedMediaRecipientId, setSelectedMediaRecipientId] = useState("");
  const [selectedGenerationId, setSelectedGenerationId] = useState("");

  const [campaignDialogOpen, setCampaignDialogOpen] = useState(false);
  const [recipientDialogOpen, setRecipientDialogOpen] = useState(false);
  const [csvDialogOpen, setCsvDialogOpen] = useState(false);
  const [addToCampaignDialogOpen, setAddToCampaignDialogOpen] = useState(false);
  const [updateEmailDialogOpen, setUpdateEmailDialogOpen] = useState(false);
  const [sendDialogOpen, setSendDialogOpen] = useState(false);

  const [viewEmailDialogOpen, setViewEmailDialogOpen] = useState(false);
  const [addRecipientsDialogOpen, setAddRecipientsDialogOpen] = useState(false);
  const [selectedCampaignRecipientsIds, setSelectedCampaignRecipientsIds] =
    useState([]);
  const [viewEmailData] = useState({
    subject: "",
    body: "",
  });

  const [tableLoading, setTableLoading] = useState(true);
  const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
  const [apiopen, setapiOpen] = useState(false);
  const [apierrorMsg, setapierrorMsg] = useState("");

  const [toggle, setToggle] = useState(false);
  const [faqData, setfaqData] = useState("2");
  const [initialfaqDateval, SetInitialfaqDateval] = useState([]);
  const [campaignRecipientsDialogOpen, setCampaignRecipientsDialogOpen] =
    useState(false);

  const [campaignForm, setCampaignForm] = useState({
    user_domain_id: userDomainId,
    campaign_name: "",
    subject: "",
    email_body: "",
    sender_name: "",
    sender_email: "",
  });

  const [recipientForm, setRecipientForm] = useState({
    name: "",
    email: "",
    company: "",
    role: "",
  });

  const [csvFile, setCsvFile] = useState(null);
  const [useAIGeneration, setUseAIGeneration] = useState(false);
  const [campaignAIPrompt, setCampaignAIPrompt] = useState("");

  const [generatedEmail, setGeneratedEmail] = useState(null);

  const authHeaders = useMemo(
    () => ({
      Authorization: `${ApiToken}`,
      "Content-Type": "application/json",
    }),
    [ApiToken]
  );

  const showResponse = (type, title, message) => {
    if (type === "success") {
      toast.success(message || title);
    } else {
      setapiOpen(true);
      setapierrorMsg(message || title || "Something went wrong");
    }
  };
  const apihandleClose = () => {
    setapiOpen(false);
  };

  const faqdatafun = useCallback(
    async (menuKey = "recipients") => {
      const menuId = OUTREACH_FAQ_MENU_ID;

      try {
        const res = await axios.get(
          `${API_BASE}domain/frequently_asked_questions/?menu=${menuId}`,
          { headers: { Authorization: `${ApiToken}` } }
        );

        if (res?.data?.faqs) {
          SetInitialfaqDateval(res.data.faqs);
        }
      } catch (err) {
        console.error("FAQ error:", err);
      }
    },
    [ApiToken]
  );

  const handleToggle = () => {
    setfaqData(faqData !== 1 ? 1 : 2);
    setToggle((prev) => !prev);
  };

  const fetchCampaigns = useCallback(async () => {
    if (!ApiToken) return;

    try {
      setLoading(true);
      setTableLoading(true);

      const res = await axios.get(
        `${API_BASE}ai_media_campaign/media_campaign_list/?user_domain_id=${userDomainId}`,
        { headers: authHeaders }
      );

      setCampaigns(res.data?.campaigns || []);
    } catch (err) {
      showResponse(
        "error",
        "Request Failed",
        err?.response?.data?.error || "Unable to load campaigns"
      );
    } finally {
      setLoading(false);
      setTableLoading(false);
    }
  }, [ApiToken, authHeaders, userDomainId]);

  const fetchMediaRecipients = useCallback(async () => {
    if (!ApiToken) return;

    try {
      setTableLoading(true);

      const res = await axios.get(
        `${API_BASE}ai_media_campaign/media_recipient_list/?user_domain_id=${userDomainId}`,
        { headers: authHeaders }
      );

      setMediaRecipients(res.data?.recipients || []);
    } catch (err) {
      setapiOpen(true);
      setapierrorMsg(err?.response?.data?.error || "Unable to load recipients");
    } finally {
      setLoading(false);
      setTableLoading(false);
    }
  }, [ApiToken, authHeaders, userDomainId]);

  const fetchGeneratedEmails = useCallback(async () => {
    if (!ApiToken) return;

    try {
      const res = await axios.get(
        `${API_BASE}ai_media_campaign/generated_emails/?user_domain_id=${userDomainId}`,
        { headers: authHeaders }
      );

      setGeneratedEmails(res.data?.generated_emails || []);
    } catch (err) {
      console.error("Generated emails list error:", err);
    }
  }, [ApiToken, authHeaders, userDomainId]);

  const fetchCampaignRecipients = async (campaign, changeTab = true) => {
    if (!campaign?.id) return [];

    try {
      setSelectedCampaign(campaign);
      setSelectedCampaignId(campaign.id);
      setLoading(true);
      setTableLoading(true);

      const res = await axios.get(
        `${API_BASE}ai_media_campaign/media_campaign_recipients/?campaign_id=${campaign.id}&user_domain_id=${userDomainId}`,
        { headers: authHeaders }
      );

      const list = res.data?.recipients || [];
      setCampaignRecipients(list);

      if (changeTab) {
        setActiveTab("campaigns");
        setCurrentMenu("campaigns");
        setCurrentMenuName("Campaigns");
      }

      return list;
    } catch (err) {
      showResponse(
        "error",
        "Request Failed",
        err?.response?.data?.error || "Unable to load campaign recipients"
      );
      return [];
    } finally {
      setLoading(false);
      setTableLoading(false);
    }
  };

  useEffect(() => {
    fetchCampaigns();
    fetchMediaRecipients();
    fetchGeneratedEmails();
    faqdatafun("recipients");
  }, [fetchCampaigns, fetchMediaRecipients, fetchGeneratedEmails, faqdatafun]);

  const SwitchMenu = (e) => {
    const id = e.currentTarget.dataset.id;
    const name = e.currentTarget.dataset.name;

    setCurrentMenu(id);
    setCurrentMenuName(name);
    setActiveTab(id);
    setfaqData(2);
    setToggle(false);
    faqdatafun(id);
  };

  const stats = useMemo(() => {
    const totalCampaigns = campaigns.length;
    const totalRecipients = mediaRecipients.length;
    const sent = campaigns.reduce((a, c) => a + (c.total_sent || 0), 0);
    const failed = campaigns.reduce((a, c) => a + (c.total_failed || 0), 0);

    return {
      totalCampaigns,
      totalRecipients,
      emailsGenerated: generatedEmails.length,
      sent,
      failed,
    };
  }, [campaigns, mediaRecipients, generatedEmails]);

  const cardDatas = [
    {
      title: "Recipients",
      value: stats.totalRecipients,
      iconSrc: RecipientsIcon,
      altText: "Recipients",
      iconColor: 2,
      bgColor: 2,
    },
    {
      title: "Campaigns",
      value: stats.totalCampaigns,
      iconSrc: CampaignIcon,
      altText: "Campaigns",
      iconColor: 1,
      bgColor: 1,
    },
    {
      title: "Emails Generated",
      value: stats.emailsGenerated,
      iconSrc: AIEmailIcon,
      altText: "Emails Generated",
      iconColor: 3,
      bgColor: 3,
    },
    {
      title: "Emails Sent",
      value: stats.sent,
      iconSrc: SentMailIcon,
      altText: "Emails Sent",
      iconColor: 4,
      bgColor: 4,
    },
  ];

  const addManualRecipient = async () => {
    if (!recipientForm.name.trim() || !recipientForm.email.trim()) {
      showResponse("error", "Validation Error", "Name and email are required");
      return;
    }

    try {
      setLoading(true);
      setTableLoading(true);

      const res = await axios.post(
        `${API_BASE}ai_media_campaign/create_media_recipients/`,
        {
          user_domain_id: userDomainId,
          recipients: [recipientForm],
        },
        { headers: authHeaders }
      );

      showResponse(
        "success",
        "Recipient Saved",
        res.data?.message || "Recipient saved successfully"
      );

      setRecipientDialogOpen(false);
      setRecipientForm({ name: "", email: "", company: "", role: "" });
      fetchMediaRecipients();
    } catch (err) {
      showResponse(
        "error",
        "Request Failed",
        err?.response?.data?.error || "Failed to save recipient"
      );
    } finally {
      setLoading(false);
      setTableLoading(false);
    }
  };

  const uploadRecipientCSV = async () => {
    if (!csvFile) {
      showResponse("error", "Validation Error", "Please select a CSV file");
      return;
    }

    const formData = new FormData();
    formData.append("user_domain_id", userDomainId);

    if (selectedCampaignId) {
      formData.append("campaign_id", selectedCampaignId);
    }

    formData.append("file", csvFile);

    try {
      setLoading(true);
      setTableLoading(true);

      const res = await axios.post(
        `${API_BASE}ai_media_campaign/upload_recipient_csv/`,
        formData,
        {
          headers: {
            Authorization: `${ApiToken}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      showResponse(
        "success",
        "CSV Uploaded",
        `Created: ${res.data?.created_count || 0}, Updated: ${res.data?.updated_count || 0
        }, Attached: ${res.data?.attached_to_campaign_count || 0}`
      );

      setCsvDialogOpen(false);
      setCsvFile(null);
      fetchMediaRecipients();
      fetchCampaigns();

      const campaignObj = campaigns.find(
        (item) => String(item.id) === String(selectedCampaignId)
      );

      if (campaignObj) {
        fetchCampaignRecipients(campaignObj, false);
      }
    } catch (err) {
      showResponse(
        "error",
        "Request Failed",
        err?.response?.data?.error || "CSV upload failed"
      );
    } finally {
      setLoading(false);
      setTableLoading(false);
    }
  };

  const addSingleRecipientToCampaign = async () => {
    if (!selectedCampaignId) {
      showResponse("error", "Validation Error", "Select a campaign first");
      return;
    }

    if (!selectedMediaRecipientId) {
      showResponse("error", "Validation Error", "Select a recipient first");
      return;
    }

    const campaignObj = campaigns.find(
      (item) => String(item.id) === String(selectedCampaignId)
    );

    try {
      setLoading(true);
      setTableLoading(true);

      const res = await axios.post(
        `${API_BASE}ai_media_campaign/add_existing_recipients_to_campaign/`,
        {
          campaign_id: selectedCampaignId,
          recipient_ids: [selectedMediaRecipientId],
        },
        { headers: authHeaders }
      );

      const alreadyAdded =
        res.data?.already_exists_count || res.data?.duplicate_count || 0;

      if (alreadyAdded > 0) {
        showResponse(
          "success",
          "Already Added",
          "This recipient is already attached to the selected campaign."
        );
      } else {
        showResponse(
          "success",
          "Recipient Added",
          res.data?.message || "Recipient added successfully"
        );
      }

      setAddToCampaignDialogOpen(false);
      setSelectedMediaRecipientId("");

      if (campaignObj) {
        setSelectedCampaign(campaignObj);
        fetchCampaignRecipients(campaignObj, false);
      }

      fetchCampaigns();
    } catch (err) {
      showResponse(
        "error",
        "Request Failed",
        err?.response?.data?.error || "Failed to add recipient to campaign"
      );
    } finally {
      setLoading(false);
      setTableLoading(false);
    }
  };

  const createCampaign = async () => {
    if (!campaignForm.campaign_name.trim()) {
      showResponse("error", "Validation Error", "Campaign name is required");
      return;
    }

    if (!useAIGeneration && !campaignForm.subject.trim()) {
      showResponse("error", "Validation Error", "Subject is required");
      return;
    }

    if (useAIGeneration && !campaignAIPrompt.trim()) {
      showResponse("error", "Validation Error", "AI prompt is required");
      return;
    }

    try {
      setLoading(true);
      setTableLoading(true);

      const createRes = await axios.post(
        `${API_BASE}ai_media_campaign/create_media_campaign/`,
        {
          ...campaignForm,
          user_domain_id: userDomainId,
          subject: useAIGeneration
            ? "AI Generated Subject"
            : campaignForm.subject,
          email_body: useAIGeneration ? "" : campaignForm.email_body,
        },
        { headers: authHeaders }
      );

      if (useAIGeneration && createRes.data?.campaign_id) {
        const genRes = await axios.post(
          `${API_BASE}ai_media_campaign/generate_ai_email/`,
          {
            campaign_id: createRes.data.campaign_id,
            prompt: campaignAIPrompt,
          },
          { headers: authHeaders }
        );

        setGeneratedEmail({
          generation_id: genRes.data?.generation_id,
          subject: genRes.data?.subject || "",
          body: genRes.data?.body || "",
        });
      }

      showResponse(
        "success",
        "Campaign Created",
        createRes.data?.message || "Campaign created successfully"
      );

      setCampaignDialogOpen(false);
      setUseAIGeneration(false);
      setCampaignAIPrompt("");

      setCampaignForm({
        user_domain_id: userDomainId,
        campaign_name: "",
        subject: "",
        email_body: "",
        sender_name: "",
        sender_email: "",
      });

      fetchCampaigns();
      fetchGeneratedEmails();
      setActiveTab("campaigns");
      setCurrentMenu("campaigns");
      setCurrentMenuName("Campaigns");
    } catch (err) {
      showResponse(
        "error",
        "Request Failed",
        err?.response?.data?.error || "Campaign creation failed"
      );
    } finally {
      setLoading(false);
      setTableLoading(false);
    }
  };

  const openUpdateEmailForCampaign = (campaign) => {
    setSelectedCampaign(campaign);
    setSelectedCampaignId(campaign.id);
    setSelectedGenerationId("");

    const latestEmail = generatedEmails.find(
      (item) => String(item.campaign_id) === String(campaign.id)
    );

    if (latestEmail) {
      setSelectedGenerationId(latestEmail.id);
      setGeneratedEmail({
        generation_id: latestEmail.id,
        subject:
          latestEmail.final_subject || latestEmail.generated_subject || "",
        body: latestEmail.final_body || latestEmail.generated_body || "",
        is_manual_campaign_email: false,
      });
    } else {
      setGeneratedEmail({
        generation_id: null,
        subject: campaign.subject || "",
        body: campaign.email_body || "",
        is_manual_campaign_email: true,
      });
    }

    setUpdateEmailDialogOpen(true);
  };

  const updateGeneratedEmail = async () => {
    if (!selectedGenerationId && !generatedEmail?.generation_id) {
      showResponse("error", "Validation Error", "Select generated email first");
      return;
    }

    if (!generatedEmail?.subject?.trim() || !generatedEmail?.body?.trim()) {
      showResponse(
        "error",
        "Validation Error",
        "Subject and body are required"
      );
      return;
    }

    try {
      setLoading(true);
      setTableLoading(true);

      const res = await axios.post(
        `${API_BASE}ai_media_campaign/update_generated_email/`,
        {
          generation_id: selectedGenerationId || generatedEmail.generation_id,
          subject: generatedEmail.subject,
          body: generatedEmail.body,
        },
        { headers: authHeaders }
      );

      showResponse(
        "success",
        "Email Updated",
        res.data?.message || "Email updated successfully"
      );

      setUpdateEmailDialogOpen(false);
      fetchGeneratedEmails();
    } catch (err) {
      showResponse(
        "error",
        "Request Failed",
        err?.response?.data?.error || "Email update failed"
      );
    } finally {
      setLoading(false);
      setTableLoading(false);
    }
  };

  const openSendDialogForCampaign = async (campaign) => {
    setSelectedCampaign(campaign);
    setSelectedCampaignId(campaign.id);

    const list = await fetchCampaignRecipients(campaign, false);

    if (!list.length) {
      showResponse(
        "error",
        "No Recipients",
        "No recipients are attached to this campaign"
      );
      return;
    }

    const latestEmail = generatedEmails.find(
      (item) => String(item.campaign_id) === String(campaign.id)
    );

    if (latestEmail) {
      setSelectedGenerationId(latestEmail.id);
      setGeneratedEmail({
        generation_id: latestEmail.id,
        subject:
          latestEmail.final_subject || latestEmail.generated_subject || "",
        body: latestEmail.final_body || latestEmail.generated_body || "",
      });
    } else {
      setSelectedGenerationId("");
      setGeneratedEmail(null);
    }

    setSendDialogOpen(true);
  };

  const addMultipleRecipientsToCampaign = async () => {
    if (!selectedCampaignId) {
      showResponse("error", "Validation Error", "Select a campaign first");
      return;
    }

    if (selectedCampaignRecipientsIds.length === 0) {
      showResponse(
        "error",
        "Validation Error",
        "Select at least one recipient"
      );
      return;
    }

    const campaignObj = campaigns.find(
      (item) => String(item.id) === String(selectedCampaignId)
    );

    try {
      setLoading(true);
      setTableLoading(true);

      const res = await axios.post(
        `${API_BASE}ai_media_campaign/add_existing_recipients_to_campaign/`,
        {
          campaign_id: selectedCampaignId,
          recipient_ids: selectedCampaignRecipientsIds,
        },
        { headers: authHeaders }
      );

      const addedCount = res.data?.created_count || 0;
      const alreadyAdded =
        res.data?.already_exists_count || res.data?.duplicate_count || 0;

      let message = "";

      if (addedCount > 0) {
        message += `${addedCount} recipient(s) added successfully. `;
      }

      if (alreadyAdded > 0) {
        message += `${alreadyAdded} recipient(s) already exist in this campaign.`;
      }

      showResponse(
        "success",
        "Recipients Updated",
        message || res.data?.message || "Recipients processed successfully"
      );

      setAddRecipientsDialogOpen(false);
      setSelectedCampaignRecipientsIds([]);

      if (campaignObj) {
        fetchCampaignRecipients(campaignObj, false);
      }

      fetchCampaigns();
    } catch (err) {
      showResponse(
        "error",
        "Request Failed",
        err?.response?.data?.error || "Failed to add recipients to campaign"
      );
    } finally {
      setLoading(false);
      setTableLoading(false);
    }
  };

  const sendCampaignEmails = async () => {
    if (!selectedCampaignId) {
      showResponse("error", "Validation Error", "Select a campaign first");
      return;
    }

    if (!selectedGenerationId && !generatedEmail?.generation_id) {
      showResponse("error", "Validation Error", "Select generated email first");
      return;
    }

    const campaignRecipientIds = campaignRecipients
      .filter((item) => item.status === "pending")
      .map((item) => item.campaign_recipient_id);

    if (campaignRecipientIds.length === 0) {
      showResponse(
        "error",
        "Validation Error",
        "No pending campaign recipients found"
      );
      return;
    }

    try {
      setLoading(true);
      setTableLoading(true);

      const res = await axios.post(
        `${API_BASE}ai_media_campaign/send_campaign_email/`,
        {
          campaign_id: selectedCampaignId,
          generation_id: selectedGenerationId || generatedEmail.generation_id,
          campaign_recipient_ids: campaignRecipientIds,
        },
        { headers: authHeaders }
      );

      showResponse(
        "success",
        "Campaign Sent",
        `Sent: ${res.data?.sent_count || 0}, Failed: ${res.data?.failed_count || 0
        }`
      );

      setSendDialogOpen(false);

      if (selectedCampaign) {
        fetchCampaignRecipients(selectedCampaign, false);
      }

      fetchCampaigns();
    } catch (err) {
      showResponse(
        "error",
        "Request Failed",
        err?.response?.data?.error || "Sending failed"
      );
    } finally {
      setLoading(false);
      setTableLoading(false);
    }
  };

  const mediaRecipientRows = mediaRecipients.map((item, index) => ({
    ...item,
    id: item.id || index + 1,
  }));

  const campaignRows = campaigns.map((item, index) => ({
    ...item,
    id: item.id || index + 1,
  }));

  const historyRows = generatedEmails.map((item, index) => ({
    ...item,
    id: item.id || index + 1,
  }));

  const sentRows = campaigns
    .filter((item) => item.total_sent > 0)
    .map((item, index) => ({
      ...item,
      id: item.id || index + 1,
    }));

  const recipientColumns = [
    {
      field: "name",
      headerName: "Name",
      description: "Recipient Name",
      minWidth: 180,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "email",
      headerName: "Email",
      description: "Recipient email address",
      minWidth: 240,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "company",
      headerName: "Company",
      description: "Recipient company name",
      minWidth: 190,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "role",
      headerName: "Role",
      description: "Recipient role or position",
      minWidth: 160,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    // {
    //   field: "source",
    //   headerName: "Source",
    //   minWidth: 130,
    //   flex: 1,
    //   headerAlign: "center",
    //   align: "center",
    // },
    {
      field: "action",
      headerName: "Action",
      description: "Add this recipient to a campaign.",
      minWidth: 190,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (params) => (
        <button
          className="view-report-button"
          style={{
            minWidth: "135px",
            width: "auto",
            whiteSpace: "nowrap",
          }}
          onClick={() => {
            setSelectedMediaRecipientId(params.row.id);
            setSelectedCampaignId("");
            setAddToCampaignDialogOpen(true);
          }}
        >
          Add to Campaign
        </button>
      ),
    },
  ];

  const campaignColumns = [
    {
      field: "campaign_name",
      headerName: "Campaign Name",
      description: "Name of the outreach campaign",
      minWidth: 220,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "subject",
      headerName: "Subject",
      description: "Email subject used for this campaign",
      minWidth: 260,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "total_recipients",
      headerName: "Recipients",
      description: "Email subject used for this campaign",
      minWidth: 130,
      flex: 1,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => params.row.total_recipients ?? 0,
    },
    {
      field: "total_sent",
      headerName: "Sent",
      description: "Total emails sent",
      minWidth: 110,
      flex: 1,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => params.row.total_sent ?? 0,
    },
    {
      field: "total_failed",
      headerName: "Failed",
      description: "Total failed emails",
      minWidth: 110,
      flex: 1,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => params.row.total_failed ?? 0,
    },
    {
      field: "status",
      headerName: "Status",
      description: "Campaign status",
      minWidth: 130,
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <span className={`oa-badge ${params.row.status || "draft"}`}>
          {params.row.status || "draft"}
        </span>
      ),
    },
    {
      field: "recipient_action",
      headerName: "Recipient Action",
      description: "View campaign recipients or add existing recipients to this campaign.",
      minWidth: 310,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (params) => (
        <div className="oa-table-action-wrap">
          <button
            className="view-report-button"
            style={{
              backgroundColor: "#ff601f",
              color: "white",
              border: "none",
              padding: "6px 12px",
              borderRadius: "4px",
              cursor: "pointer",
              fontSize: "13px",
              fontWeight: "700",
              minWidth: "70px",
              whiteSpace: "nowrap",
            }}
            onClick={async () => {
              await fetchCampaignRecipients(params.row, false);
              setCampaignRecipientsDialogOpen(true);
            }}
          >
            View
          </button>

          <button
            className="view-report-button"
            style={{
              backgroundColor: "#ff601f",
              color: "white",
              border: "none",
              padding: "6px 12px",
              borderRadius: "4px",
              cursor: "pointer",
              fontSize: "13px",
              fontWeight: "700",
              minWidth: "70px",
              whiteSpace: "nowrap",
            }}
            onClick={() => {
              setSelectedCampaign(params.row);
              setSelectedCampaignId(params.row.id);
              setSelectedCampaignRecipientsIds([]);
              setAddRecipientsDialogOpen(true);
            }}
          >
            Add
          </button>
        </div>
      ),
    },
    {
      field: "action",
      headerName: "Email Action",
      description: "Update or send the campaign email.",
      minWidth: 350,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (params) => (
        <div className="oa-table-action-wrap">
          <button
            className="view-report-button"
            // style={{
            //   // minWidth: "1px",
            //   // width: "auto",
            //   // whiteSpace: "nowrap",
            // }}
            onClick={() => openUpdateEmailForCampaign(params.row)}
          >
            Update
          </button>

          <button
            className="view-report-button"
            // style={{
            //   // minWidth: "1px",
            //   // width: "auto",
            //   // whiteSpace: "nowrap",
            // }}
            onClick={() => openSendDialogForCampaign(params.row)}
          >
            Send
          </button>
        </div>
      ),
    },
  ];

  const historyColumns = [
    {
      field: "campaign__campaign_name",
      headerName: "Campaign",
      description: "The campaign for which the AI email was generated.",
      minWidth: 220,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "prompt",
      headerName: "Prompt",
      description: "The prompt used to generate the outreach email.",
      minWidth: 260,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "final_subject",
      headerName: "Subject",
      description: "The final or AI-generated email subject.",
      minWidth: 260,
      flex: 1,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        params.row.final_subject || params.row.generated_subject || "-",
    },
    {
      field: "is_edited",
      headerName: "Edited",
      description: "Shows whether the generated email was edited manually.",
      minWidth: 120,
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (params.row.is_edited ? "Yes" : "No"),
    },
    {
      field: "created_at",
      headerName: "Created At",
      minWidth: 180,
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) =>
        params.row.created_at
          ? new Date(params.row.created_at)
            .toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })
            .replace(/ /g, " ")
          : "-",
    },
  ];

  const sentColumns = campaignColumns.filter((col) => col.field !== "action");

  return (
    <div className="over_all_container over_all_accessibility outreach-assistant-page">
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Helmet>
        <meta charSet="utf-8" />
        <title>AI Outreach Assistant</title>
      </Helmet>

      <CommonAlert setOpenCommonAlerts={setOpenCommonAlerts} />

      {loading === true ? <Loader /> : null}

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={4}>
              <h1 className="dashboard_header">
                {CurrentMenuName}
                <span className="faq-chip" onClick={handleToggle}>
                  FAQ's
                </span>
              </h1>
            </Grid>

            <Grid item xs={12} md={8}>
              <div className="top_breadcrumb_menu">
                <div className="exportpdf_outer">
                  <div className="breadcrumb-wrapper">
                    <CommonBreadCrumb
                      breadcrumbValue={[
                        { title: "Dashboard" },
                        { title: "Outreach Assistant" },
                        { title: CurrentMenuName, activeColor: true },
                      ]}
                    />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box-tab">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div className="trendy-tabs-wrapper">
                <div className="trendy-tab-container">
                  {[
                    ["recipients", "Recipients"],
                    ["campaigns", "Campaigns"],
                    ["history", "Email Generation History"],
                    ["sent", "Sent Campaigns"],
                  ].map(([id, name]) => (
                    <button
                      key={id}
                      type="button"
                      data-id={id}
                      data-name={name}
                      className={`trendy-tab ${CurrentMenu === id ? "active" : ""
                        }`}
                      onClick={SwitchMenu}
                    >
                      {name}
                    </button>
                  ))}
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box-time">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={6}></Grid>

            <Grid item xs={12} md={6}>
              <div className="drop_down_button">
                {activeTab === "recipients" && (
                  <>
                    <button
                      className="btn_dashboard"
                      onClick={() => {
                        setfaqData(2);
                        setToggle(false);
                        setRecipientDialogOpen(true);
                      }}
                    >
                      Add Recipient
                    </button>

                    <button
                      className="btn_dashboard"
                      onClick={() => {
                        setCsvFile(null);
                        setSelectedCampaignId("");
                        setCsvDialogOpen(true);
                      }}
                    >
                      Upload CSV
                    </button>
                  </>
                )}

                {activeTab === "campaigns" && (
                  <button
                    className="btn_dashboard"
                    onClick={() => {
                      setfaqData(2);
                      setToggle(false);
                      setCampaignDialogOpen(true);
                    }}
                  >
                    Create Campaign
                  </button>
                )}
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Grid
          container
          spacing={2}
          style={{ marginBottom: "20px", marginTop: "10px" }}
        >
          {cardDatas.map((item, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Commoncard item={item} nonclikable={true} />
            </Grid>
          ))}
        </Grid>
      </Container>

      {activeTab === "recipients" && (
        <Container
          maxWidth={false}
          className="dashboard-container table-search-break"
        >
          <Box className="grid_table_shodow">
            <Grid container className="dashboard-grid">
              <Grid item xs={12} md={12}>
                <div className="cnt_audit_outer_wrap table-100-height">
                  <DatagridComp
                    className="datagrid_custom_scroll"
                    columns={recipientColumns}
                    rows={mediaRecipientRows}
                    autoheightval={true}
                    datagridval={2}
                    columnFreezeWidth={[0]}
                    tableLoading={tableLoading}
                    customFilter={false}
                    DownloadShowFile={false}
                  />
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>
      )}

      {activeTab === "campaigns" && (
        <Container
          maxWidth={false}
          className="dashboard-container table-search-break"
        >
          <Box className="grid_table_shodow">
            <Grid container className="dashboard-grid">
              <Grid item xs={12} md={12}>
                <div className="cnt_audit_outer_wrap table-100-height">
                  <DatagridComp
                    className="datagrid_custom_scroll"
                    columns={campaignColumns}
                    rows={campaignRows}
                    autoheightval={true}
                    datagridval={2}
                    columnFreezeWidth={[0]}
                    tableLoading={tableLoading}
                    customFilter={false}
                    DownloadShowFile={false}
                  />
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>
      )}

      {activeTab === "history" && (
        <Container
          maxWidth={false}
          className="dashboard-container table-search-break"
        >
          <Box className="grid_table_shodow">
            <Grid container className="dashboard-grid">
              <Grid item xs={12} md={12}>
                <div className="cnt_audit_outer_wrap table-100-height">
                  <DatagridComp
                    className="datagrid_custom_scroll"
                    columns={historyColumns}
                    rows={historyRows}
                    autoheightval={true}
                    datagridval={2}
                    columnFreezeWidth={[0]}
                    tableLoading={tableLoading}
                    customFilter={false}
                    DownloadShowFile={false}
                  />
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>
      )}

      {activeTab === "sent" && (
        <Container
          maxWidth={false}
          className="dashboard-container table-search-break"
        >
          <Box className="grid_table_shodow">
            <Grid container className="dashboard-grid">
              <Grid item xs={12} md={12}>
                <div className="cnt_audit_outer_wrap table-100-height">
                  <DatagridComp
                    className="datagrid_custom_scroll"
                    columns={sentColumns}
                    rows={sentRows}
                    autoheightval={true}
                    datagridval={2}
                    columnFreezeWidth={[0]}
                    tableLoading={tableLoading}
                    customFilter={false}
                    DownloadShowFile={false}
                  />
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>
      )}

      {!openCommonAlerts && (
        <CommonErrorAlert
          data={{
            apiopen: apiopen,
            apiErrorMsg: apierrorMsg,
            isIconStyled: true,
          }}
          closeAlert={apihandleClose}
        />
      )}

      {toggle && (
        <Rightsidebar
          close={() => setToggle(false)}
          setToggle={setToggle}
          initialfaqDateval={initialfaqDateval}
        />
      )}

      <RecipientDialog
        open={recipientDialogOpen}
        onClose={() => setRecipientDialogOpen(false)}
        form={recipientForm}
        setForm={setRecipientForm}
        onSubmit={addManualRecipient}
      />

      <CSVUploadDialog
        open={csvDialogOpen}
        onClose={() => setCsvDialogOpen(false)}
        campaigns={campaigns}
        selectedCampaignId={selectedCampaignId}
        setSelectedCampaignId={setSelectedCampaignId}
        setCsvFile={setCsvFile}
        onSubmit={uploadRecipientCSV}
      />

      <AddToCampaignDialog
        open={addToCampaignDialogOpen}
        onClose={() => setAddToCampaignDialogOpen(false)}
        campaigns={campaigns}
        selectedCampaignId={selectedCampaignId}
        setSelectedCampaignId={setSelectedCampaignId}
        onSubmit={addSingleRecipientToCampaign}
      />

      <CampaignDialog
        open={campaignDialogOpen}
        onClose={() => setCampaignDialogOpen(false)}
        form={campaignForm}
        setForm={setCampaignForm}
        useAIGeneration={useAIGeneration}
        setUseAIGeneration={setUseAIGeneration}
        campaignAIPrompt={campaignAIPrompt}
        setCampaignAIPrompt={setCampaignAIPrompt}
        onSubmit={createCampaign}
      />

      <UpdateEmailDialog
        open={updateEmailDialogOpen}
        onClose={() => setUpdateEmailDialogOpen(false)}
        generatedEmails={generatedEmails}
        selectedCampaignId={selectedCampaignId}
        selectedGenerationId={selectedGenerationId}
        setSelectedGenerationId={setSelectedGenerationId}
        generatedEmail={generatedEmail}
        setGeneratedEmail={setGeneratedEmail}
        onSubmit={updateGeneratedEmail}
      />

      <SendCampaignDialog
        open={sendDialogOpen}
        onClose={() => setSendDialogOpen(false)}
        generatedEmails={generatedEmails}
        selectedCampaignId={selectedCampaignId}
        selectedGenerationId={selectedGenerationId}
        setSelectedGenerationId={setSelectedGenerationId}
        setGeneratedEmail={setGeneratedEmail}
        campaignRecipients={campaignRecipients}
        onSubmit={sendCampaignEmails}
      />

      <ViewEmailDialog
        open={viewEmailDialogOpen}
        onClose={() => setViewEmailDialogOpen(false)}
        data={viewEmailData}
      />

      <AddRecipientsToCampaignDialog
        open={addRecipientsDialogOpen}
        onClose={() => setAddRecipientsDialogOpen(false)}
        mediaRecipients={mediaRecipients}
        selectedCampaignRecipientsIds={selectedCampaignRecipientsIds}
        setSelectedCampaignRecipientsIds={setSelectedCampaignRecipientsIds}
        onSubmit={addMultipleRecipientsToCampaign}
      />

      <CampaignRecipientsDialog
        open={campaignRecipientsDialogOpen}
        onClose={() => setCampaignRecipientsDialogOpen(false)}
        campaignRecipients={campaignRecipients}
        selectedCampaign={selectedCampaign}
      />

      <Container maxWidth={false} className="footer-container">
        <Box className="footer-box">
          <Grid container className="footer-grid">
            <Grid item xs={12} md={6}>
              <div className="footer-left">
                <p className="footer-text">
                  All Rights Reserved Copyright © 2026 |
                  <a href="https://www.elitesiteoptimizer.ai/" target="blank">
                    <span className="footer-brand"> Elite Site Optimizer</span>
                  </a>
                </p>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="footer-right">
                <p></p>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </div>
  );
}

function RecipientDialog({ open, onClose, form, setForm, onSubmit }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      className="run_report_now_modal"
    >
      <DialogTitle
        className="keyword-dialog-header"
        style={{ textAlign: "center" }}
      >
        Add Recipient
      </DialogTitle>

      <DialogContent>
        <div
          className="ai-form-container"
          style={{ border: "none", boxShadow: "none", padding: "10px 0" }}
        >
          <div className="ai-form-group">
            <label className="ai-form-label">
              Name <span style={{ color: "#ff601f" }}>*</span>
            </label>
            <input
              className="ai-form-input"
              placeholder="Enter recipient name"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
            />
          </div>

          <div className="ai-form-group">
            <label className="ai-form-label">
              Email <span style={{ color: "#ff601f" }}>*</span>
            </label>
            <input
              type="email"
              className="ai-form-input"
              placeholder="john@example.com"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
            />
          </div>

          <div className="ai-form-group">
            <label className="ai-form-label">Company</label>
            <input
              className="ai-form-input"
              placeholder="Enter company name"
              value={form.company}
              onChange={(e) => setForm({ ...form, company: e.target.value })}
            />
          </div>

          <div className="ai-form-group">
            <label className="ai-form-label">Role</label>
            <input
              className="ai-form-input"
              placeholder="Editor / Journalist"
              value={form.role}
              onChange={(e) => setForm({ ...form, role: e.target.value })}
            />
          </div>
        </div>
      </DialogContent>

      <DialogActions
        className="dialog_box_btn"
        style={{ paddingBottom: "30px" }}
      >
        <button className="ai-submit-btn" onClick={onSubmit}>
          Save Recipient
        </button>
        <button className="ai-reset-btn" onClick={onClose}>
          Cancel
        </button>
      </DialogActions>
    </Dialog>
  );
}

function CSVUploadDialog({
  open,
  onClose,
  campaigns,
  selectedCampaignId,
  setSelectedCampaignId,
  setCsvFile,
  onSubmit,
}) {
  const downloadSampleCSV = () => {
    const csvHeader = "name,email,company,role\n";
    const csvRows =
      "Emily,emily@example.com,eGrove Systems,Content Strategist\n" +
      "David,sarah@example.com,Elite Media,Journalist\n";

    const csvContent = csvHeader + csvRows;

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = "sample_recipients.csv";
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      className="run_report_now_modal"
    >
      <DialogTitle
        className="keyword-dialog-header"
        style={{ textAlign: "center" }}
      >
        Upload Recipient CSV
      </DialogTitle>

      <DialogContent>
        <div
          className="ai-form-container"
          style={{ border: "none", boxShadow: "none", padding: "10px 0" }}
        >
          <div className="ai-form-group">
            <label className="ai-form-label">
              Attach to Campaign Optional{" "}
              <Tooltip
                arrow
                placement="right"
                title="If you select a campaign, uploaded recipients will be saved and attached to that campaign. If you leave it as No Campaign, recipients will only be saved in the recipient list and can be added to campaigns later."
              >
                <span className="oa-help-icon">?</span>
              </Tooltip>
            </label>

            <select
              className="ai-form-input"
              value={selectedCampaignId}
              onChange={(e) => setSelectedCampaignId(e.target.value)}
            >
              <option value="">No Campaign</option>
              {campaigns.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.campaign_name}
                </option>
              ))}
            </select>
          </div>

          <div
            className="ai-form-hint"
            style={{
              marginBottom: "12px",
              lineHeight: "1.6",
            }}
          >
            Required CSV header:
            <br />
            <b>name,email,company,role</b>
          </div>

          <div className="ai-form-group">
            <button
              type="button"
              className="ai-reset-btn"
              onClick={downloadSampleCSV}
              style={{
                marginBottom: "12px",
                width: "auto",
                padding: "8px 16px",
              }}
            >
              Download Sample CSV
            </button>
          </div>

          <div className="ai-form-group">
            <label className="ai-form-label">
              CSV File <span style={{ color: "#ff601f" }}>*</span>{" "}
              <Tooltip
                arrow
                placement="right"
                title={
                  <div>
                    <div>
                      <b>Sample CSV Format</b>
                    </div>
                    <div>name,email,company,role</div>
                    <div>John Doe,john@example.com,ABC Company,Editor</div>
                    <div>Sarah Smith,sarah@example.com,XYZ Media,Journalist</div>
                  </div>
                }
              >
                <span className="oa-help-icon">?</span>
              </Tooltip>
            </label>

            <input
              type="file"
              accept=".csv"
              className="ai-form-input"
              onChange={(e) => setCsvFile(e.target.files?.[0] || null)}
            />
          </div>
        </div>
      </DialogContent>

      <DialogActions
        className="dialog_box_btn"
        style={{ paddingBottom: "30px" }}
      >
        <button className="ai-submit-btn" onClick={onSubmit}>
          Upload CSV
        </button>
        <button className="ai-reset-btn" onClick={onClose}>
          Cancel
        </button>
      </DialogActions>
    </Dialog>
  );
}

function CampaignRecipientsDialog({
  open,
  onClose,
  campaignRecipients,
  selectedCampaign,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      className="run_report_now_modal"
    >
      <DialogTitle
        className="keyword-dialog-header"
        style={{ textAlign: "center" }}
      >
        Campaign Recipients
      </DialogTitle>

      <DialogContent>
        <div
          className="ai-form-container"
          style={{
            border: "none",
            boxShadow: "none",
            padding: "10px 0",
          }}
        >
          <div
            style={{
              marginBottom: "12px",
              fontSize: "14px",
              fontWeight: "600",
              color: "#374151",
            }}
          >
            Campaign: {selectedCampaign?.campaign_name || "-"}
          </div>

          <div className="oa-recipient-select-box">
            {campaignRecipients.length === 0 ? (
              <div className="ai-form-hint">
                No recipients attached to this campaign.
              </div>
            ) : (
              campaignRecipients.map((item, index) => (
                <div
                  key={index}
                  className="oa-recipient-check"
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <div style={{ fontWeight: "600" }}>{item.name || "-"}</div>

                    <div
                      style={{
                        fontSize: "12px",
                        color: "#6b7280",
                      }}
                    >
                      {item.email}
                    </div>
                  </div>

                  <div>
                    <span className={`oa-badge ${item.status || "pending"}`}>
                      {item.status || "pending"}
                    </span>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </DialogContent>

      <DialogActions
        className="dialog_box_btn"
        style={{ paddingBottom: "30px" }}
      >
        <button className="ai-reset-btn" onClick={onClose}>
          Close
        </button>
      </DialogActions>
    </Dialog>
  );
}

function AddToCampaignDialog({
  open,
  onClose,
  campaigns,
  selectedCampaignId,
  setSelectedCampaignId,
  onSubmit,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      className="run_report_now_modal"
    >
      <DialogTitle
        className="keyword-dialog-header"
        style={{ textAlign: "center" }}
      >
        Add Recipient to Campaign
      </DialogTitle>

      <DialogContent>
        <div
          className="ai-form-container"
          style={{ border: "none", boxShadow: "none", padding: "10px 0" }}
        >
          <div className="ai-form-group">
            <label className="ai-form-label">
              Select Campaign <span style={{ color: "#ff601f" }}>*</span>
            </label>
            <select
              className="ai-form-input"
              value={selectedCampaignId}
              onChange={(e) => setSelectedCampaignId(e.target.value)}
            >
              <option value="">Select Campaign</option>
              {campaigns.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.campaign_name}
                </option>
              ))}
            </select>
          </div>
        </div>
      </DialogContent>

      <DialogActions
        className="dialog_box_btn"
        style={{ paddingBottom: "30px" }}
      >
        <button className="ai-submit-btn" onClick={onSubmit}>
          Add to Campaign
        </button>
        <button className="ai-reset-btn" onClick={onClose}>
          Cancel
        </button>
      </DialogActions>
    </Dialog>
  );
}

function CampaignDialog({
  open,
  onClose,
  form,
  setForm,
  useAIGeneration,
  setUseAIGeneration,
  campaignAIPrompt,
  setCampaignAIPrompt,
  onSubmit,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      className="run_report_now_modal"
    >
      <DialogTitle
        className="keyword-dialog-header"
        style={{ textAlign: "center" }}
      >
        Create Campaign
      </DialogTitle>

      <DialogContent>
        <div
          className="ai-form-container"
          style={{ border: "none", boxShadow: "none", padding: "10px 0" }}
        >
          <div className="ai-form-group">
            <label className="ai-form-label">
              Campaign Name <span style={{ color: "#ff601f" }}>*</span>
            </label>
            <input
              className="ai-form-input"
              value={form.campaign_name}
              onChange={(e) =>
                setForm({ ...form, campaign_name: e.target.value })
              }
            />
          </div>

          <div className="ai-form-group">
            <label className="ai-form-label">Sender Name</label>
            <input
              className="ai-form-input"
              value={form.sender_name}
              onChange={(e) =>
                setForm({ ...form, sender_name: e.target.value })
              }
            />
          </div>

          <div className="ai-form-group">
            <label className="ai-form-label">Sender Email</label>
            <input
              type="email"
              className="ai-form-input"
              value={form.sender_email}
              onChange={(e) =>
                setForm({ ...form, sender_email: e.target.value })
              }
            />
          </div>

          <div className="ai-form-group">
            <label className="ai-form-label">
              <input
                type="checkbox"
                checked={useAIGeneration}
                onChange={(e) => setUseAIGeneration(e.target.checked)}
                style={{ marginRight: "8px" }}
              />
              Generate AI email and subject
            </label>
          </div>

          {useAIGeneration ? (
            <div className="ai-form-group">
              <label className="ai-form-label">
                AI Prompt <span style={{ color: "#ff601f" }}>*</span>
              </label>
              <textarea
                className="ai-form-input"
                style={{ minHeight: "140px" }}
                value={campaignAIPrompt}
                onChange={(e) => setCampaignAIPrompt(e.target.value)}
                placeholder="Write a professional outreach email for SEO collaboration."
              />
            </div>
          ) : (
            <>
              <div className="ai-form-group">
                <label className="ai-form-label">
                  Subject <span style={{ color: "#ff601f" }}>*</span>
                </label>
                <input
                  className="ai-form-input"
                  value={form.subject}
                  onChange={(e) =>
                    setForm({ ...form, subject: e.target.value })
                  }
                />
              </div>

              <div className="ai-form-group">
                <label className="ai-form-label">Email Body</label>
                <textarea
                  className="ai-form-input"
                  style={{
                    minHeight: "120px",
                    resize: "vertical",
                  }}
                  value={form.email_body}
                  onChange={(e) =>
                    setForm({ ...form, email_body: e.target.value })
                  }
                />
              </div>
            </>
          )}
        </div>
      </DialogContent>

      <DialogActions
        className="dialog_box_btn"
        style={{ paddingBottom: "30px" }}
      >
        <button className="ai-submit-btn" onClick={onSubmit}>
          Create Campaign
        </button>
        <button className="ai-reset-btn" onClick={onClose}>
          Cancel
        </button>
      </DialogActions>
    </Dialog>
  );
}

function UpdateEmailDialog({
  open,
  onClose,
  generatedEmails,
  selectedCampaignId,
  selectedGenerationId,
  setSelectedGenerationId,
  generatedEmail,
  setGeneratedEmail,
  onSubmit,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      className="run_report_now_modal"
    >
      <DialogTitle
        className="keyword-dialog-header"
        style={{ textAlign: "center" }}
      >
        Update Generated Email
      </DialogTitle>

      <DialogContent>
        <div
          className="ai-form-container"
          style={{ border: "none", boxShadow: "none", padding: "10px 0" }}
        >
          <div className="ai-form-hint" style={{ marginBottom: "12px" }}>
            You can use dynamic placeholders like <b>{"{{name}}"}</b> and{" "}
            <b>{"{{company}}"}</b>. These will be replaced with each recipient's
            name and company when the campaign email is sent.
          </div>
          <div className="ai-form-group">
            <label className="ai-form-label">
              Subject <span style={{ color: "#ff601f" }}>*</span>
            </label>
            <input
              className="ai-form-input"
              value={generatedEmail?.subject || ""}
              onChange={(e) =>
                setGeneratedEmail({
                  ...generatedEmail,
                  subject: e.target.value,
                })
              }
            />
          </div>

          <div className="ai-form-group">
            <label className="ai-form-label">
              Body <span style={{ color: "#ff601f" }}>*</span>
            </label>
            <textarea
              className="ai-form-input"
              style={{ minHeight: "180px" }}
              value={generatedEmail?.body || ""}
              onChange={(e) =>
                setGeneratedEmail({ ...generatedEmail, body: e.target.value })
              }
            />
          </div>
        </div>
      </DialogContent>

      <DialogActions
        className="dialog_box_btn"
        style={{ paddingBottom: "30px" }}
      >
        <button className="ai-submit-btn" onClick={onSubmit}>
          Update Email
        </button>
        <button className="ai-reset-btn" onClick={onClose}>
          Cancel
        </button>
      </DialogActions>
    </Dialog>
  );
}

function SendCampaignDialog({
  open,
  onClose,
  generatedEmails,
  selectedCampaignId,
  selectedGenerationId,
  setSelectedGenerationId,
  setGeneratedEmail,
  campaignRecipients,
  onSubmit,
}) {
  const filteredEmails = generatedEmails.filter(
    (item) => String(item.campaign_id) === String(selectedCampaignId)
  );

  const pendingCount = campaignRecipients.filter(
    (item) => item.status === "pending"
  ).length;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      className="run_report_now_modal"
    >
      <DialogTitle
        className="keyword-dialog-header"
        style={{ textAlign: "center" }}
      >
        Send Campaign Email
      </DialogTitle>

      <DialogContent>
        <div
          className="ai-form-container"
          style={{ border: "none", boxShadow: "none", padding: "10px 0" }}
        >
          <div className="ai-form-group">
            <label className="ai-form-label">
              Select Generated Email <span style={{ color: "#ff601f" }}>*</span>
            </label>
            <select
              className="ai-form-input"
              value={selectedGenerationId}
              onChange={(e) => {
                const generation = generatedEmails.find(
                  (item) => String(item.id) === String(e.target.value)
                );

                setSelectedGenerationId(e.target.value);

                if (generation) {
                  setGeneratedEmail({
                    generation_id: generation.id,
                    subject:
                      generation.final_subject ||
                      generation.generated_subject ||
                      "",
                    body:
                      generation.final_body || generation.generated_body || "",
                  });
                }
              }}
            >
              <option value="">Select Generated Email</option>
              {filteredEmails.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.final_subject || item.generated_subject}
                </option>
              ))}
            </select>
          </div>

          <div className="ai-form-hint">
            Pending campaign recipients: {pendingCount}
          </div>
        </div>
      </DialogContent>

      <DialogActions
        className="dialog_box_btn"
        style={{ paddingBottom: "30px" }}
      >
        <button className="ai-submit-btn" onClick={onSubmit}>
          Send Email
        </button>
        <button className="ai-reset-btn" onClick={onClose}>
          Cancel
        </button>
      </DialogActions>
    </Dialog>
  );
}

function ViewEmailDialog({ open, onClose, data }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      className="run_report_now_modal"
    >
      <DialogTitle
        className="keyword-dialog-header"
        style={{ textAlign: "center" }}
      >
        Campaign Email Preview
      </DialogTitle>

      <DialogContent>
        <div
          className="ai-form-container"
          style={{ border: "none", boxShadow: "none", padding: "10px 0" }}
        >
          <div className="ai-form-group">
            <label className="ai-form-label">Subject</label>
            <input
              className="ai-form-input"
              value={data?.subject || ""}
              readOnly
            />
          </div>

          <div className="ai-form-group">
            <label className="ai-form-label">Email Body</label>
            <textarea
              className="ai-form-input"
              style={{ minHeight: "250px" }}
              value={data?.body || ""}
              readOnly
            />
          </div>
        </div>
      </DialogContent>

      <DialogActions
        className="dialog_box_btn"
        style={{ paddingBottom: "30px" }}
      >
        <button className="ai-reset-btn" onClick={onClose}>
          Close
        </button>
      </DialogActions>
    </Dialog>
  );
}

function AddRecipientsToCampaignDialog({
  open,
  onClose,
  mediaRecipients,
  selectedCampaignRecipientsIds,
  setSelectedCampaignRecipientsIds,
  onSubmit,
}) {
  const toggleRecipient = (recipientId) => {
    const id = String(recipientId);

    setSelectedCampaignRecipientsIds((prev) => {
      const existing = prev.map(String);

      if (existing.includes(id)) {
        return prev.filter((item) => String(item) !== id);
      }

      return [...prev, recipientId];
    });
  };

  const allSelected =
    mediaRecipients.length > 0 &&
    selectedCampaignRecipientsIds.length === mediaRecipients.length;

  const toggleAll = () => {
    if (allSelected) {
      setSelectedCampaignRecipientsIds([]);
    } else {
      setSelectedCampaignRecipientsIds(mediaRecipients.map((item) => item.id));
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      className="run_report_now_modal"
    >
      <DialogTitle
        className="keyword-dialog-header"
        style={{ textAlign: "center" }}
      >
        Add Recipients to Campaign
      </DialogTitle>

      <DialogContent>
        <div
          className="ai-form-container"
          style={{ border: "none", boxShadow: "none", padding: "10px 0" }}
        >
          <div className="ai-form-group">
            <label className="ai-form-label">
              Select Recipients <span style={{ color: "#ff601f" }}>*</span>
            </label>

            <div className="oa-recipient-select-box">
              <label className="oa-recipient-check oa-recipient-check-all">
                <input
                  type="checkbox"
                  checked={allSelected}
                  onChange={toggleAll}
                />
                Select All
              </label>

              {mediaRecipients.length === 0 ? (
                <div className="ai-form-hint">No recipients found</div>
              ) : (
                mediaRecipients.map((item) => (
                  <label key={item.id} className="oa-recipient-check">
                    <input
                      type="checkbox"
                      checked={selectedCampaignRecipientsIds
                        .map(String)
                        .includes(String(item.id))}
                      onChange={() => toggleRecipient(item.id)}
                    />
                    <span>
                      {item.name || "-"} — {item.email}
                      {item.company ? ` (${item.company})` : ""}
                    </span>
                  </label>
                ))
              )}
            </div>
          </div>
        </div>
      </DialogContent>

      <DialogActions
        className="dialog_box_btn"
        style={{ paddingBottom: "30px" }}
      >
        <button className="ai-submit-btn" onClick={onSubmit}>
          Add Selected Recipients
        </button>
        <button className="ai-reset-btn" onClick={onClose}>
          Cancel
        </button>
      </DialogActions>
    </Dialog>
  );
}
